export default __webpack_public_path__ + "static/media/maintenance.aff298e9.svg";